import { render, staticRenderFns } from "./manage-2fa.vue?vue&type=template&id=92dce916&"
import script from "./manage-2fa.vue?vue&type=script&lang=js&"
export * from "./manage-2fa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports